import { toUpperCaseFirstChar } from '../../theme';
import moment from 'moment/moment';
import { getYearAndMonthInStringDate } from '../dashboard';
var concatYearsAndMonth = function (annee, month) {
    return annee * 100 + month;
};
var formatNumber = function (number, unit, fixed) {
    if (unit === void 0) { unit = ''; }
    if (fixed === void 0) { fixed = 2; }
    if (unit === '%' || unit === '€') {
        number = (Math.round((number ? number : 0) * 100) / 100).toFixed(fixed);
    }
    number = number
        ? number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        : 0;
    return unit ? number + ' ' + unit : number;
};
var formatDateTime = function (date, forDatabase) {
    if (forDatabase === void 0) { forDatabase = true; }
    if (typeof date == 'string') {
        date = new Date(date);
    }
    return (formatDate(date, forDatabase) +
        ' ' +
        checkZero(date.getHours()) +
        ':' +
        checkZero(date.getMinutes()) +
        ':' +
        checkZero(date.getSeconds()));
};
var dateDiffToString = function (date1, date2) {
    var tmp = new Date(date2).getTime() - new Date(date1).getTime();
    tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
    var sec = tmp % 60; // Extraction du nombre de secondes
    tmp = Math.floor((tmp - sec) / 60); // Nombre de minutes (partie entière)
    var min = tmp % 60; // Extraction du nombre de minutes
    tmp = Math.floor((tmp - min) / 60); // Nombre d'heures (entières)
    var hour = tmp % 24; // Extraction du nombre d'heures
    tmp = Math.floor((tmp - hour) / 24); // Nombre de jours restants
    var day = tmp;
    var values = [];
    if (day > 0) {
        values.push("".concat(day, "j."));
    }
    else if (hour > 0) {
        values.push("".concat(hour, "h."));
        values.push("".concat(min, "min."));
    }
    else if (min > 0) {
        values.push("".concat(min, "min."));
    }
    return values.join(' ');
};
var formatDateString = function (date) {
    return toUpperCaseFirstChar(new Date(date).toLocaleString('fr-FR', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }));
};
var formatDayString = function (date) {
    return toUpperCaseFirstChar(new Date(date).toLocaleString('fr-FR', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
    }));
};
var formatPeriodeString = function (dateDebut, dateFin) {
    var values = [];
    var date1 = dateDebut ? new Date(dateDebut).toLocaleString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }) : null;
    var date2 = dateFin ? new Date(dateFin).toLocaleString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }) : null;
    if (date1 && date2) {
        date1 = date1.replace(date2.split(' ')[1], '').replace(date2.split(' ')[2], '');
    }
    return "".concat(date1 ? "Du ".concat(date1) : "D'une date indéterminée", " ").concat(date2 ? "au ".concat(date2) : 'à une date indéterminée');
};
var formatDate = function (date, forDatabase) {
    if (forDatabase === void 0) { forDatabase = true; }
    if (!forDatabase && (date == null || date == '0000-00-00')) {
        return '-';
    }
    if (typeof date == 'string') {
        date = new Date(date);
    }
    var annee = date.getFullYear();
    var mois = checkZero(date.getMonth() + 1);
    var jour = checkZero(date.getDate());
    if (forDatabase) {
        return annee + '-' + mois + '-' + jour;
    }
    else {
        return jour + '/' + mois + '/' + annee;
    }
};
var checkZero = function (value) {
    if (value < 10) {
        return '0' + value;
    }
    return value;
};
var downloadFile = function (_a) {
    var data = _a.data, fileName = _a.fileName, fileType = _a.fileType;
    // Create a blob with the data we want to download as a file
    var blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: fileType });
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    var a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    var clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
};
var dateStartOfWeek = function (date) {
    if (date === void 0) { date = new Date(); }
    return moment(date).startOf('week').toDate();
};
var dateEndOfWeek = function (date) {
    if (date === void 0) { date = new Date(); }
    return moment(date).endOf('week').toDate();
};
var dateStartOfTrimestre = function (date) {
    if (date === void 0) { date = new Date(); }
    return moment(date).startOf('quarter').toDate();
};
var dateEndOfTrimestre = function (date) {
    if (date === void 0) { date = new Date(); }
    return moment(date).endOf('quarter').toDate();
};
var addDays = function (currentDate, days) {
    var date = new Date(currentDate);
    date.setDate(date.getDate() + days);
    return date;
};
var getDatesBetweenTowDates = function (startDate, endDate) {
    var dates = [];
    var currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
        dates.push(currentDate);
        currentDate = addDays(currentDate, 1);
    }
    return dates;
};
var getMonthBetweenTowMonth = function (min, max) {
    var values = [min];
    while (!values.includes(max)) {
        var monthAndYear = values[values.length - 1];
        var _a = getYearAndMonthInStringDate(monthAndYear), Annee = _a.Annee, Mois = _a.Mois;
        if (Mois >= 12) {
            Mois = 1;
            Annee += 1;
        }
        else {
            Mois += 1;
        }
        values.push(concatYearsAndMonth(Annee, Mois));
    }
    return values;
};
export { formatNumber, formatDate, formatDateTime, dateDiffToString, formatDateString, downloadFile, addDays, formatDayString, formatPeriodeString, dateStartOfTrimestre, dateEndOfTrimestre, getDatesBetweenTowDates, dateStartOfWeek, dateEndOfWeek, concatYearsAndMonth, getMonthBetweenTowMonth };
//# sourceMappingURL=utils.js.map